import MainHeader from './components/MainHeader';
import ShareLink from './components/ShareLink';

/**
 * Controller class.
 *
 * Standardizes how we hook into event listeners and create components.
 */
class Controller {
	constructor() {
		this.init();

		window.addEventListener('resize', this.resized);
		window.addEventListener('load', this.loaded);
	}

	init() {
		MainHeader.init();
		ShareLink.init();
	}

	resized() {
		MainHeader.resized();
	}

	loaded() {
		MainHeader.loaded();
	}
}

// Run controller.
new Controller();

// Initialize MicroModal globally when available.
window.addEventListener('load', () => {
	if (window.MicroModal) {
		window.MicroModal.init({ awaitOpenAnimation: true, awaitCloseAnimation: true });
	}
});
